export default {
  breakpoints: ['600px', '900px', '1200px', '1800px'],
  fonts: {
    base: 'Lato, Helvetica, Arial, sans-serif',
    touchScreen: 'ModernEra, Jost, Arial, sans-serif',
    heading: 'Montserrat, Helvetica, Arial, sans-serif',
    serif: 'PT Serif, serif',
    icon: 'Font Awesome 5 Pro',
  },
  fontWeights: {
    '100': 100,
    '200': 200,
    '300': 300,
    '400': 400,
    '500': 500,
    '600': 600,
    '700': 700,
    '800': 800,
    '900': 900,
  },

  borders: {
    none: 0,
    xs: '1px solid',
    sm: '4px solid',
    md: '5px solid',
    dashed: '2px dashed',
  },
  fontSizes: {
    '10': '10px',
    '11': '11px',
    '12': '12px',
    '13': '13px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '22': '22px',
    '26': '26px',
    '28': '28px',
    '32': '32px',
    '40': '40px',
    '48': '48px',
    '52': '52px',
    '64': '64px',
  },
  space: {
    '0': '0px',
    '4': '4px',
    '6': '6px',
    '8': '8px',
    '11': '11px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '22': '22px',
    '26': '26px',
    '30': '30px',
    '32': '32px',
    '38': '38px',
    '44': '44px',
    '48': '48px',
    '52': '52px',
    '60': '60px',
    '64': '64px',
  },
  lineHeights: {
    xxSmall: 0.9,
    xSmall: 1,
    small: 1.14,
    medium: 1.25,
    large: 1.34,
    xLarge: 1.43,
    xxLarge: 1.5,
  },
  letterSpacings: {
    none: 0,
    negativeSmall: '-0.2px',
    negativeMedium: '-0.3px',
    negativeLarge: '-0.4px',
    small: '0.2px',
    medium: '0.4px',
    large: '1px',
  },
  radii: {
    none: 0,
    sm: '3px',
    md: '6px',
    lg: '12px',
    xl: '24px',
    full: '50%',
  },
  shadows: {
    small: '0 6px 10px 0 rgba(199, 200, 204, 0.1)',
    medium: '0 6px 10px 0 rgba(199, 200, 204, 0.15)',
    large: '0 6px 10px 0 rgba(199, 200, 204, 0.25)',
    xlarge: '0 6px 10px 0 rgba(199, 200, 204, 0.4)',
    negativeSmall: '0 -6px 10px 0 rgba(199, 200, 204, 0.1)',
    negativeMedium: '0 -6px 10px 0 rgba(199, 200, 204, 0.15)',
    negativeLarge: '0 -6px 10px 0 rgba(199, 200, 204, 0.25)',
    negativeXLarge: '0 -6px 10px 0 rgba(199, 200, 204, 0.4)',
  },
  borderStyles: {
    solid: 'solid',
    dashed: 'dashed',
    dotted: 'dotted',
    double: 'double',
  },
  borderWidths: {
    none: 0,
    small: '1px',
    medium: '2px',
    large: '4px',
  },
  colorShadeDefinition: {
    saturation: 0,
    light: 0.05,
  },
  colors: {
    variants: {
      primary: { bg: 'teal', hover: { bg: 'teal_darker' }, color: 'white' },
      secondary: { bg: 'black', hover: { bg: 'black_darker' }, color: 'white' },
      alternative: { bg: 'blue_darker', hover: { bg: 'softBlue' }, color: 'white' },
      success: { bg: 'green', hover: { bg: 'green_darker' }, color: 'white' },
      danger: { bg: 'red', hover: { bg: 'red_darker' }, color: 'white' },
      warning: { bg: 'yellow', hover: { bg: 'yellow_darker' }, color: 'white' },
      info: { bg: 'blue', hover: { bg: 'blue_darker' }, color: 'white' },
      light: { bg: 'grey_light', hover: { bg: 'grey' }, color: 'white' },
      dark: { bg: 'grey_dark', hover: { bg: 'grey_darker' }, color: 'white' },
    },
    text: {
      h1: 'grey_darker',
      h2: 'grey_dark',
      h3: 'steel_dark',
      h4: 'steel',
      h5: 'grey',
      h6: 'grey_lighter',
      body: '#7f7f7f',
      link: '#4a90e2',
      input: '#6b6b6b',
      inputPlaceholder: '#bbbbbb',
      button_dark: 'black',
      button_light: 'white',
      button_disabled: 'grey_lighter',
      button_outline: 'grey',
    },
    palette: {
      black: '#000',
      white: '#ffffff',
      softGrey: {
        default: '#edf2f7',
        darker: '#d7dfe9',
      },
      grey: {
        lighter: '#c9c9c9',
        light: '#bbb',
        default: '#9b9b9b',
        dark: '#707070',
        darker: '#4a4a4a',
      },
      hardGrey: {
        default: '#2E2E2E',
      },
      sky: {
        default: '#e5eefe',
      },
      lapis: {
        default: '#599ffb',
      },
      blue: {
        lighter: '#cbd5e0',
        light: '#c7c9d9',
        default: '#96bce8',
        dark: '#84addb',
        darker: '#2f80ed',
      },
      softBlue: {
        lighter: '#E5F0FF',
        light: '#9dbff9',
        default: '#5b8def',
        dark: '#3382e9',
      },
      hardBlue: {
        default: '#070151',
        darker: '#555770',
      },
      brown: {
        default: '#a5673f',
        dark: '#995b32',
      },
      green: {
        lighter: '#e3fff1',
        light: '#c2e89b',
        default: '#9ad6a6',
        dark: '#87c994',
        darker: '#06c270',
      },
      hardGreen: {
        lighter: '#57eba1',
        light: '#16e104',
        default: '#39d98a',
      },
      lime: {
        default: '#b8e986',
        dark: '#a8db74',
      },
      olive: {
        default: '#b5cc18',
        dark: '#a8bf0d',
      },
      orange: {
        lighter: '#fff8e6',
        light: '#ffd986',
        default: '#fac486',
        dark: '#eeb574',
        darker: '#fdac42',
      },
      hardOrange: {
        default: '#ff8800',
      },
      pink: {
        lighter: '#ffe6ff',
        default: '#e03997',
        dark: '#d42a8a',
      },
      purple: {
        light: '#6b6d89',
        default: '#abb4eb',
        dark: '#97a0de',
        darker: '#767896',
      },
      darkPurple: {
        default: '#ac5dd9',
      },
      red: {
        lighter: '#ffe6e6',
        default: '#ef7d8d',
        dark: '#e36b7b',
        darker: '#ff5c5c',
      },
      hardRed: {
        default: '#ff3b3b',
      },
      teal: {
        default: '#50e3c2',
        dark: '#42bda2',
      },
      violet: {
        default: '#6435c9',
        dark: '#5728bd',
      },
      yellow: {
        lighter: '#FFF7DF',
        default: '#ffd578',
        dark: '#f2c666',
        darker: '#C2A146',
      },
      hardYellow: {
        default: '#F3EA00',
      },
      slate: {
        100: '#E5E5E5',
        lighter: '#E2E8F0',
        light: '#b0b8d1',
        default: '#5c5f68',
        dark: '#4a5568',
        darker: '#2d3748',
      },
      snow: {
        lighter: '#fafafa',
        light: '#f0f1f4',
        default: '#e0e0e0',
        dark: '#dadada',
        darker: '#a0aec0',
      },
      steel: {
        lighter: '#ededf1',
        light: '#dcdde6',
        default: '#d9dae2',
        dark: '#b8b9c1',
        darker: '#b5b6bd',
      },
      aqua: {
        lighter: '#e6ffff',
        default: '#73dfe7',
      },
    },
  },
};
